import React from 'react';
import { abmTokens as ajaxClient } from '../../ajax_clients';
import ActionDropDown from "../shared/action_drop_down";
import pagedTableLayout from '../paged_table/layout';
import { bindMethods, callWithIds } from '../../shared/functions';
import RetireUsersModal from './retire_users_modal';

const getAjaxClient = () => ({
    ...ajaxClient,
    destroyMultiple: (abmTokens) => {
        return callWithIds(abmTokens, ajaxClient.destroyMultiple).then((responses) => {
            const failedResponses = responses.filter(({ status }) => status === 'rejected');
            const failureCount    = failedResponses.length;
            if (failureCount > 0) {
                const abmToken = failureCount > 1 ? 'vpp tokens' : 'vpp token';
                window.addFlashAlert('error', `Failed to remove ${ failureCount } ${ abmToken }.`)
            } else {
                window.addFlashAlert('notice', 'Selected vpp tokens have been removed')
            }

            return responses;
        })
    }
});

class ABMTokensPagedTable extends React.Component {

    constructor(props) {
        super(props);
        bindMethods(this);
        this.state = {
            showRetireUsersModal: false
        };
    }

    showRetireUsersModal(e) {
        e.preventDefault();
        this.setState({ showRetireUsersModal: true });
    }

    hideRetireUsersModal() {
        this.setState({ showRetireUsersModal: false });
    }

    renderActionButton() {
        const items = [
            {
                href:         "#delete",
                action:       this.props.removeItems,
                text:         "Delete",
                policy:       'destroy',
            }
        ];

        if (this.canRetireUsers()) {
            items.push(
                {
                    href: "#retire-users",
                    action: this.showRetireUsersModal,
                    text: "Retire ABM Users",
                    policy: 'create'
                }
            );
        }

        return <ActionDropDown policy={ this.props.policy } text="Actions" items={ items }
                               disabled={ !this.props.hasCheckedItems() }/>
    }

    renderAdditionalActions() {
        const additionalActions = [];
        if (this.props.policy.create) {
            additionalActions.push(
                <a key="add-token" href={ AdminRoutes.newAdminABMTokenPath({format: null}) } className="pull-right btn btn-primary">
                    Add Token
                </a>
            )
        }

        if (this.canRefresh()) {
            additionalActions.push(
                <a key="sync" href={ AdminRoutes.refreshAdminABMTokensPath({format: null}) } className="pull-right btn btn-default">
                    Sync with Apple
                </a>
            )
        }


        return additionalActions;
    }

    canRefresh() {
        return this.props.policy.refresh && this.props.data.length > 0
    }

    canRetireUsers() {
        return this.props.policy.create && this.props.data.length > 0 && this.props.meta.retireABMUsers
    }

    tokenIdentifierHeader() {
        return { displayName: "Location Name", key: "locationName" }
    }

    pagedTableProps() {
        return {
            headers:   [
                { displayName: "Organization Name", key: "organizationName" },
                this.tokenIdentifierHeader(),
                { displayName: "Licenses", key: "licenses" },
                { displayName: "Status", key: "status" },
                { displayName: "", key: "renew" },
            ],
            renderRow: (row) => {
                let status;
                if (row.tokenRejected) {
                    status = (
                        <span className="label label-danger label-rejected">
                            <span className="glyphicon glyphicon-alert"/>
                            Rejected by Apple
                        </span>
                    )
                } else if (row.expired) {
                    status = (
                        <span className="label label-danger label-rejected">
                            <span className="glyphicon glyphicon-alert"/>
                            Expired { row.expirationDate }
                        </span>
                    )
                } else {
                    status = `Expires ${ row.expirationDate }`
                }
                const renew =  <a href={ AdminRoutes.adminABMTokenPath(row.id, {format: null}) } className='btn btn-sm btn-default pull-right'>
                    Renew
                </a>;
                return { ...row, status, renew }
            }
        }
    }

    renderMessage() {
        let message = (
            <p>
                Managed distribution allows you to assign and remove app licenses to iOS devices using Apple's Volume Purchase Program.
                If you are enrolled in Apple's Volume Purchase Program, you can retrieve your managed
                distribution
                token
                from the <a
                href="https://business.apple.com/#/main/preferences/paymentsandbilling/appsandbooks"
                target="_blank"
                rel="noopener noreferrer">
                Volume Purchase Program Portal</a>.
            </p>
        );
        return <React.Fragment>
            { message }
            <p>
                <strong>Note:</strong>
                If you purchase licenses from Apple after adding your token, it can take a few minutes before they
                appear in SimpleMDM.
            </p>
        </React.Fragment>;
    }

    render() {
        const notFound = (
            <div className="centered alert alert-info" role="alert">
                No VPP tokens have been added yet.
            </div>
        );

        const actions = (
            <div className="button-list-container">
                { this.renderAdditionalActions() }
                { this.renderActionButton() }
            </div>
        );

        return (
            <>
                <div id="abm-tokens-table">
                    { this.props.renderTopSection(this.renderMessage(), actions) }
                    { this.props.dataNotFound ? notFound : this.props.renderPagedTable(this.pagedTableProps()) }
                </div>
                <RetireUsersModal
                    showModal={this.state.showRetireUsersModal}
                    onDone={this.hideRetireUsersModal}
                    tokens={this.props.checkedItems()}
                />
            </>
        )
    }
}

export default pagedTableLayout(ABMTokensPagedTable, getAjaxClient);